import Select from "@/v2-ui/select"
import { useInvoiceFollowUpStatusesQuery } from "@/v2-backoffice-client/license/collections/license.invoiceFollowUpStatuses.query"

export type LicenseInvoiceFollowUpStatusSelectProps = {
  value: string
  onValueChange(value: string): void
}

// The dunning conversation-state catalog (Contacted, Issue - sent to
// Finance) as a select, with the picked state's description as the hint
// below — owns its own catalog query so the follow-up dialog stays a
// one-operation component. The derived states (Not started, Paid) are
// deliberately absent: nobody sets those, the invoice mirror does.
function LicenseInvoiceFollowUpStatusSelect(
  props: LicenseInvoiceFollowUpStatusSelectProps,
) {
  const { value, onValueChange } = props

  const { data, loading } = useInvoiceFollowUpStatusesQuery()
  const statuses = data?.getInvoiceFollowUpStatuses ?? []
  const selected = statuses.find((status) => String(status.Code) === value)

  return (
    <>
      <Select value={value} onValueChange={onValueChange}>
        <Select.Trigger size="md" className="w-full">
          <Select.Value
            placeholder={
              loading ? "Loading statuses..." : "Where does the dialogue stand?"
            }
          />
        </Select.Trigger>
        <Select.Content>
          {statuses.map((status) => (
            <Select.Item key={status.Code} value={String(status.Code)}>
              {status.Name}
            </Select.Item>
          ))}
        </Select.Content>
      </Select>
      {selected?.Description && (
        <p className="text-xs text-muted-foreground">{selected.Description}</p>
      )}
    </>
  )
}

export default LicenseInvoiceFollowUpStatusSelect
